import React, {Component} from 'react';

import {connect} from 'react-redux'
import {locale} from '../locale/AppLocale'
import Loader from '../Components/Loader';
import * as productsByCategoryActions from '../actions/productsByCategoryActions'
import "react-image-gallery/styles/css/image-gallery.css";
import InfiniteScroll from 'react-infinite-scroller';
import Breadcrumb from '../Components/Breadcrumb';
import ListingProducts from '../Components/ListingProducts';

class SearchCategoryProducts extends Component {

    
    constructor(props) {
        super(props);
        this.loadMore = this.loadMore.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillMount() {
        this.props.resetProducts();
        this.props.fetchCategoryProduct(this.props.match.params.categoryId, this.props.match.params.keyword || '');
        this.props.updateKeyword(this.props.match.params.keyword || '');
    }

    loadMore(event) {
        if (!this.props.categoryProducts.has_more || this.props.categoryProducts.is_loading) {
            return;
        }
        if(this.props.categoryProducts.pagination.page >= this.props.categoryProducts.pagination.pages){
            return;
        }
        let page = this.props.categoryProducts.pagination.page + 1;
        this.props.fetchCategoryProduct(this.props.match.params.categoryId, this.props.match.params.keyword, page);
    }


    renderBreadcrumb() {
        let breadcrumb = [
            {url: `/${this.props.match.params.businessSlug}/search`, title_ar: locale.get('add_new_product')},
            {url: `/${this.props.match.params.businessSlug}/search/categories`, title_ar: locale.get('categories')},
        ];

        let items = this.props.categoryProducts.category.breadcrumb || [];
        items.forEach((category, index) => {
            if (index !== 0) {
                if (category.id) {
                    category.url = `/${this.props.match.params.businessSlug}/search/categories/${category.id}`;
                } else {
                    category.url = '';
                }
            }
            breadcrumb.push(category);
        });

        return (
            breadcrumb.length > 0 && <div className="panel-1--breadcrumb">
                <Breadcrumb onClickHandler={this.onClickBreadCrumb} isClickable={true} items={breadcrumb} />
            </div>
        );
    }

    renderSearchInput(){
        return (
            <div className="panel-10">
                <div className="panel-1--body search-form">
                    <form className="" onSubmit={this.onSubmit.bind(this)}>
                        <input type="text"
                               value={this.props.categoryProducts.keyword}
                               onChange={this.onChange.bind(this)}
                               className="input-search-form"
                               placeholder={locale.get('search_placeholder')}/>
                        <button className="btn-1 ">{locale.get('search')}</button>

                    </form>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }

    render() {
        return (
            <Loader completed={this.props.categoryProducts.fetched}>
                <div>
                    {this.renderBreadcrumb()}
                    <div className="clearfix"></div>
                    {this.renderSearchInput()}
                    <div className="clearfix"></div>
                    <InfiniteScroll
                        pageStart={0}
                        initialLoad={false}
                        loadMore={this.loadMore}
                        hasMore={this.props.categoryProducts.has_more === true}
                        loader={<div><Loader completed={this.props.categoryProducts.is_loading === false} />
                        </div>}
                    >

                        <ListingProducts
                            match={this.props.match}
                            products={this.props.categoryProducts.products}
                            category={this.props.categoryProducts.category}/>

                    </InfiniteScroll>

                </div>
            </Loader>
        );
    }

    onSubmit(e){
        e.preventDefault();
        this.props.history.push(`/${this.props.match.params.businessSlug}/search/categories/` + this.props.categoryProducts.category.id + '/products/' + this.props.categoryProducts.keyword);
        this.props.resetProducts();
        this.props.fetchCategoryProduct(this.props.categoryProducts.category.id, this.props.categoryProducts.keyword, '');
    }

    onChange(e){
        this.props.updateKeyword(e.target.value);
    }

}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        searchCategoriesList: state.searchCategoriesList,
        categoryProducts: state.findCategoryProducts,
    }
};

// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        updateKeyword: (keyword) => dispatch(productsByCategoryActions.updateKeyword(keyword)),
        fetchCategories: (parentId) => dispatch(productsByCategoryActions.fetchCategoriesList(parentId)),
        resetProducts: ()=>dispatch(productsByCategoryActions.resetProducts()),
        fetchCategoryProduct: (categoryId, keyword, scrollId) => dispatch(productsByCategoryActions.fetchProductsByCategory(categoryId, keyword, scrollId)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchCategoryProducts);